// Events
export const KMF_APPLICATION_POLICY_REQUEST =
  "kmfApplication/policyRequest/";

export const SUBMIT_POLICY_REQUEST=KMF_APPLICATION_POLICY_REQUEST+'submitPolicy'

export const submitPolicy = () => ({  
  type: SUBMIT_POLICY_REQUEST,
}); 
export const SUBMIT_QUOTE_REQUEST=KMF_APPLICATION_POLICY_REQUEST+'getQuote'
export const getPolicyQuote = () => ({  
  type: SUBMIT_QUOTE_REQUEST,
}); 
export const SEND_UPLOAD_DOCUMENTS=KMF_APPLICATION_POLICY_REQUEST+'uploadDocuments'

 export const uploadDocumentsRequest=()=>({
type:SEND_UPLOAD_DOCUMENTS,
})

export const SEND_LEADS_REQUEST=KMF_APPLICATION_POLICY_REQUEST+'leadsMail'


export const sendLeadsRequest = (value='') => ({  
  type: SEND_LEADS_REQUEST,
  value
}); 

export const KMF_SEND_PURCHASE_EMAIL_CUSTOMER=KMF_APPLICATION_POLICY_REQUEST+'sendPurchaseEmailCustomer'


export const sendPurchaseEmailCustomer = (value) => ({  
  type: KMF_SEND_PURCHASE_EMAIL_CUSTOMER,
  value
}); 